const updates = [
  {
    time: '10分钟前',
    tag: '快讯',
    title: '某男星被拍到深夜出入私人会所，经纪人回应称系商务应酬',
  },
  {
    time: '25分钟前',
    tag: '独家',
    title: '知名编剧被曝与制作方因剧本改编问题产生严重分歧',
  },
  {
    time: '45分钟前',
    tag: '追踪',
    title: '昨日爆出的综艺争执事件后续：节目组发布正式致歉声明',
  },
  {
    time: '1小时前',
    tag: '快讯',
    title: '51吃瓜网今日吃瓜新增匿名投稿功能，支持图片与视频上传',
  },
  {
    time: '1.5小时前',
    tag: '爆料',
    title: '某古装剧组被爆存在严重超时工作现象，演员体力透支',
  },
  {
    time: '2小时前',
    tag: '独家',
    title: '乐坛天后疑似筹备全球巡演，多城市场馆已进入预定阶段',
  },
  {
    time: '3小时前',
    tag: '快讯',
    title: '热门网剧第二季正式官宣开机，原班人马悉数回归引期待',
  },
  {
    time: '4小时前',
    tag: '追踪',
    title: '51吃瓜大赛最新票数统计出炉，首位破百万票候选人诞生',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            实时快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            分钟级更新，最新吃瓜动态一网打尽
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-primary-100">
            {updates.map((item, idx) => (
              <div
                key={idx}
                className={`relative pb-6 md:pb-8 ${idx === updates.length - 1 ? 'pb-0' : ''}`}
              >
                <div className="absolute -left-[25px] md:-left-[29px] top-0 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 mb-1">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  <span className={`inline-block px-2 py-0.5 rounded-full text-[10px] font-bold whitespace-nowrap ${
                    item.tag === '独家' ? 'bg-primary-100 text-primary-700' : item.tag === '追踪' ? 'bg-accent-100 text-accent-700' : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <a
                  href="#carousel"
                  className="text-sm md:text-base font-semibold text-foreground-900 hover:text-primary-500 transition-colors cursor-pointer leading-relaxed"
                >
                  {item.title}
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}